import { FieldDataType, FieldTypes, ValidationType } from "./types";
import { merge, concat } from "lodash";

export const addValidation = (
  formField: FieldDataType,
  validation: Partial<ValidationType>
): FieldDataType => {
  return merge({}, formField, { validations: validation });
};

export const addConfig = (
  formField: FieldDataType,
  config: Partial<FieldDataType>
): FieldDataType => {
  return merge({}, formField, config);
};

export const cleanFieldValues = (
  formFields: Record<string, FieldDataType>,
  values: Record<string, string>
) => {
  for (const [key, value] of Object.entries(values)) {
    values[key] = formFields[key]?.compact?.(value) || value;
  }
  return values;
};

const isSelectOrGroup = (
  field: FieldDataType
): field is FieldDataType<FieldTypes.select | FieldTypes.group> => {
  return field.type === FieldTypes.select || field.type === FieldTypes.group;
};

export const addOptions = (
  formField: FieldDataType,
  options: { value: string | number; description: string }[]
): FieldDataType => {
  if (!isSelectOrGroup(formField)) {
    throw new Error("Field must be of type select or radio group");
  }
  return merge({}, formField, { options: concat(formField.options, options) });
};
